import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';

import { set_window_width } from './actions';

import rootReducer from './reducers';

const store = createStore(rootReducer, applyMiddleware(thunkMiddleware));

if (typeof window === 'object') {
    store.dispatch(set_window_width({
        width: window.innerWidth,
        height: window.innerHeight,
    }));
}


if (typeof window === 'object') {
    window.addEventListener('resize', () => {
        store.dispatch(set_window_width({
            width: window.innerWidth,
            height: window.innerHeight,
        }));
    });
}


export default store;
